/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import Toast from '../toast';
import * as userService from '../../../services/userService'
import { BASE_IMAGE_PATH } from '../../../configs/api';
class LockModel extends Component {
   constructor(props) {
      super(props);
      this.state = {
         passcode: "",
         repasscode: "",
         mpassword: "",
         toastMsg: "",
         toastType: "",
      };
   }
   showToast(msg, type) {
      let self = this
      this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
         setTimeout(() => {
            self.setState({ toastMsg: "", toastType: "", showToast: false })
         }, 3000);
      })
   }
   onChange(e) {
      const name = e.target.name;
      const value = e.target.value;
      this.setState({ [name]: value })
   }
   handleKey(e) {
      if (e.keyCode === 13) {
         this.submitForm();
      }
   }
   async submitForm() {
      if (this.state.loading) {
         return false
      }
      else {
         this.setState({ loading: true }, async() => {
            if (!this.state.mpassword) {
               this.props.notify("Please insert master password!", "error");
               this.setState({ loading: false })
               return false
            }
            let body = {
               "username": this.props.user.username,
               "masterPassword": this.state.mpassword
            }
            if (this.props.action === "userLock") {
               await userService.deActiveUser(body).then(async (res) => {
                  if (res.isSuccess) {
                     this.props.notify("Locked User Succesfully!", "success");
                     // this.props.closeAndUpdate()
                     if(this.props.showClubGames){
                        await userService.deActiveRealGamesUser(this.props.user.username).then((res) => {
                           if (res.isSuccess) {
                              this.props.notify("Also Locked Clubgames User Succesfully!", "success");
                           } else {
                              this.props.notify(res.message, "error")
                           }
                           this.props.closeAndUpdate()
                           
                        })
                     }
                     else{
                        this.props.closeAndUpdate();
                     }
                  } else {
                     this.props.notify(res.exception.message, "error")
                  }
                  setTimeout(()=>{ this.setState({loading:false})},1000)
                  
               })

            } else if (this.props.action === "userUnlock") {
               await userService.activeUser(body).then(async (res) => {
                  if (res.isSuccess) {
                     this.props.notify("Unlocked User Succesfully!", "success");
                     // this.props.closeAndUpdate()
                     if(this.props.showClubGames){
                        await userService.activeRealGamesUser(this.props.user.username).then((res) => {
                           if (res.isSuccess) {
                              this.props.notify("Also Unlocked Clubgames User Succesfully!", "success");
                           } else {
                              this.props.notify(res.message, "error")
                           }
                           this.props.closeAndUpdate()
                           
                        })
                     }
                     else{
                        this.props.closeAndUpdate();
                     }
                  } else {
                     this.props.notify(res.exception.message, "error")
                  }
                  setTimeout(()=>{ this.setState({loading:false})},1000)
                  
               })
            } else if (this.props.action === "betLock") {
               await userService.blockUser(body).then(async (res) => {
                  if (res.isSuccess) {
                     this.props.notify("Bet Locked Succesfully!", "success");
                     //this.props.closeAndUpdate()
                     if(this.props.showClubGames){
                        await userService.blockRealGamesUser(this.props.user.username).then((res) => {
                           if (res.isSuccess) {
                              this.props.notify("Also Bet Locked Clubgames Succesfully!", "success");
                           } else {
                              this.props.notify(res.message, "error")
                           }
                           this.props.closeAndUpdate()
                        })
                     }
                     else{
                        this.props.closeAndUpdate();
                     }
                  } else {
                     this.props.notify(res.exception.message, "error")
                  }
                  setTimeout(()=>{ this.setState({loading:false})},1000)
                  
               })
            } else if (this.props.action === "betUnlock") {
               await userService.unBlockUser(body).then(async (res) => {
                  if (res.isSuccess) {
                     this.props.notify("Bet Unlocked Succesfully!", "success");
                     //this.props.closeAndUpdate()
                     if(this.props.showClubGames){
                        await userService.unBlockRealGamesUser(this.props.user.username).then((res) => {
                           if (res.isSuccess) {
                              this.props.notify("Also Bet Unlocked Clubgames Succesfully!", "success");
                           } else {
                              this.props.notify(res.message, "error")
                           }                 
                           this.props.closeAndUpdate()
                        })
                     }
                     else{
                        this.props.closeAndUpdate();
                     }
                  } else {
                     this.props.notify(res.exception.message, "error")
                  }
                  setTimeout(()=>{ this.setState({loading:false})},1000)                  
               })
            }
         })
      }
   }
   componentDidMount() {
   }
   render() {
      return (
         <>
            <div className="modal fade show" style={{ display: 'block' }} id="mywithdraw" role="dialog" aria-modal="true">
               <div className="modal-dialog modal-dialog-scrollable">
                  <div className="modal-content">
                     <div className="modal-header">
                        <h4 className="modal-title">{this.props.action === "userLock" ? "Lock User" : this.props.action === "userUnlock" ? "Unlock User" : this.props.action === "betLock" ? "Bet Lock" : "Bet Unlock"}</h4>
                        <button type="button" className="close text-white" data-dismiss="modal" onClick={() => { this.props.closePopup() }}>×</button>
                     </div>
                     <div className="modal-body lst-pop ">
                        <div className="row m-b-20">
                           <div className="col-md-4">
                              <label>Master Password</label>
                           </div>
                           <div className="col-md-8">
                              <input type="Password" onKeyUp={(e) => { this.handleKey(e) }} name="mpassword" value={this.state.mpassword} onChange={(e) => { this.onChange(e) }} id="mpassword" required="" autoFocus />
                           </div>
                        </div>
                     </div>
                     <div className="modal-footer">
                        <a  onDoubleClickCapture={(e)=>{e.preventDefault();return false;}} onClick={() => { if (!this.state.loading) { this.submitForm() } }} tabIndex={4} style={{ cursor: "pointer" }} className="pop-edit-btn">Submit {this.state.loading && <img style={{ height: "16px" }} alt="" src={BASE_IMAGE_PATH + "/aimg/loader.gif"} />}</a>
                        &nbsp;&nbsp;
                        <a className="pop-edit-btn" tabIndex={5} style={{ cursor: "pointer" }} onClick={() => { this.props.closePopup() }} data-dismiss="modal">Cancel</a>
                     </div>
                     {!!this.state.showToast && <Toast notification={this.state.toastMsg} type={this.state.toastType} />}
                  </div>
               </div>
               <div className="modal-backdrop fade show" onClick={() => { this.props.closePopup() }}></div>
               </div>            
         </>
      )
   }
}

function mapStateToProps(state) {
   return {
   };
}

function mapDispatchToProps(dispatch) {
   return {
   };
}
export default connect(mapStateToProps, mapDispatchToProps)(LockModel);